module.exports = __webpack_public_path__ + "static/tasks_02@2x-f210e2ec7b39ce00e4bf16043ae09787.png";